<template>
	<svg class="vaM tra-fast" :class="sizeClass" aria-hidden="true" @click="$emit('click')">
		<use :xlink:href="iconName"></use>
	</svg>
</template>

<script>
export default {
	name: "Icon",
	props: {
		name: {
			type: String,
			required: true,
		},
		// sizeBase:{
		// 	type: String,
		// 	default:"s"
		// }
	},
	computed: {
		iconName() {
			// if (stage.iconOfUsed[this.name]) {
			// } else {
			// 	//没有调用过，记录并加载资源
			// 	stage.iconOfUsed[this.name] = true;
			// 	$("<div></div>").load(`${stage.loc.baseRouter}static/icon/${this.name}.svg?v=${stage.ver}`, (data) => {
			// 		let $ico = $(data);
			// 		if ($ico.length < 2) {
			// 			//规避掉错误的返回
			// 			$ico.find("[stroke='#000']").removeAttr("stroke");
			// 			$ico.find("title").remove();
			// 			if ($ico.find(`symbol[id=${this.name}]`).length == 0) $ico.attr("id", this.name);
			// 			$("#svg").append($ico);
			// 		}
			// 	});
			// }
			return `#${this.name}`;
		},
		sizeClass() {
			// 	switch(this.sizeBase){
			// 		case "xxs":return "fs08x";
			// 		case "xs":return "";
			// 		case "s":return "";
			// 		case "m":return "fs105x";
			// 		case "l":return "fs16x";
			// 	}
		},
	},
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/ui/SvgIcon.vue